import i18n from '../../../i18n';
import { format, getWeek, startOfWeek, endOfWeek, addWeeks, startOfMonth, endOfMonth, addMonths, subMonths } from 'date-fns';
import { fmtDateWeek } from '../../../lib/dateFormat';

// Availability types with colors
const availabilityType = (value, labelKey, shortKey, color) => ({
  value,
  color,
  get label() { return i18n.t(labelKey); },
  get shortLabel() { return i18n.t(shortKey); },
});

export const AVAILABILITY_TYPES = [
  availabilityType('vacation', 'auto.lbl.vacationHoliday', 'manpower.short.vacation', 'bg-blue-100 text-blue-800'),
  availabilityType('sick_leave', 'auto.lbl.sickLeave', 'manpower.short.sick', 'bg-red-100 text-red-800'),
  availabilityType('personal', 'auto.lbl.personalLeave', 'manpower.short.personal', 'bg-purple-100 text-purple-800'),
  availabilityType('training', 'auto.lbl.training', 'manpower.short.training', 'bg-green-100 text-green-800'),
  availabilityType('other', 'auto.lbl.other', 'manpower.short.other', 'bg-gray-100 text-gray-800'),
];

// Get availability type info by value
export const getAvailabilityTypeInfo = (type) => {
  return AVAILABILITY_TYPES.find(t => t.value === type) || AVAILABILITY_TYPES[4];
};

// Format date as YYYY.MM.DD
export const formatDateDDMMYYYY = (date) => {
  return fmtDateWeek(date);
};

// Get week number (Monday start)
export const getWeekNumber = (date) => {
  return getWeek(new Date(date), { weekStartsOn: 1 });
};

// Generate week options for dropdown navigation
export const generateWeekOptions = (centerDate, monthsBack = 6, monthsForward = 6) => {
  const options = [];
  const start = subMonths(startOfMonth(centerDate), monthsBack);
  const end = addMonths(endOfMonth(centerDate), monthsForward);
  
  let current = startOfWeek(start, { weekStartsOn: 1 });
  while (current <= end) {
    const weekEnd = endOfWeek(current, { weekStartsOn: 1 });
    const weekNum = getWeekNumber(current);
    options.push({
      value: format(current, 'yyyy-MM-dd'),
      label: `Week ${weekNum} (${formatDateDDMMYYYY(current)} - ${formatDateDDMMYYYY(weekEnd)})`
    });
    current = addWeeks(current, 1);
  }
  return options;
};

// API base URL
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
